import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import Utils from '../../utils';
import { StyledFolderCreator, FolderCreatorLabel } from './styles';
import { Translate } from 'react-redux-i18n';
import { openPanel } from '../../containers/FolderCreationPanel/actions';

interface FolderCreatorProps {
	dispatch: Dispatch<StoreState>;
}

const FolderCreatorFromSelection = ({ dispatch }: FolderCreatorProps) => {

	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		dispatch(openPanel(true));
	};

	const tooltipId = Utils.generateId();

	return (
		<StyledFolderCreator onClick={handleClick} data-tip={true} data-for={tooltipId}>
			{Utils.getSvgIcon('iconset_uprez_documents')}
			<FolderCreatorLabel>
				<Translate value={'messages.save_in_documents'} />
			</FolderCreatorLabel>
		</StyledFolderCreator>
	);
};

export default FolderCreatorFromSelection;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FolderCreatorFromSelection/index.tsx